<template>
  <v-app id="inspire">

    <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
      >
        <app-menu v-if="$store.getters.user.data"/>
      </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        <v-icon v-if="!drawer">menu</v-icon>
        <v-icon v-else>menu_open</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down">{{$store.getters.appName}}</span>
      </v-toolbar-title>
      <v-spacer />
      <span class="mr-5" v-if="$store.getters.user.data">{{ $store.getters.user.data.displayName }}</span>
      <v-menu
        transition="slide-y-transition"
        bottom
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn
            dark
            text
            fab
            small
            v-on="on"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            :to="{ name: 'Account' }"
          >
            <v-list-item-title>
              <v-icon>settings</v-icon>
              {{ $t('menu.top.profile') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="logout"
          >
            <v-list-item-title>
              <v-icon>logout</v-icon>
              {{ $t('menu.top.logout') }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-content v-show="!$store.getters.open_player">
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import * as service from '../store/service'
import MenuComponent from '../components/Menu.vue'

export default {
  components: {
    'app-menu': MenuComponent
  },

  data: () => ({
    drawer: null
  }),

  methods: {
    logout() {
      service.logout().then(() => {
        this.$router.push({ name: 'Login' })
      }).catch(function(error) {
        alert('Error: ' + error)
      })
    }
  }
}
</script>
